import {
  AppBar,
  Toolbar,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  Grid,
  MenuItem,
  Box,
  Container,
  Grow,
  Paper,
  Popper,
  MenuList,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Logo from "../../component/Logo";
import { localeFunction } from "src/utils";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
const useStyles = makeStyles((theme) => ({
  toolbar: {
    display: "flex",
    padding: "0px 0",
    justifyContent: "space-between",
    height: "100%",
    "@media (max-width: 900px)": {
      paddingLeft: "75px",
      paddingRight: "20px",
      height: "100%",
    },
  },

  logoDrawer: {
    paddingLeft: "10px",
    width: "194px",
  },
  drawerContainer: {
    padding: "20px 0px ",
    height: "100%",
    background: "#fff",
    width: "260px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
  },
  drawericon: {
    color: "#000",
    position: "absolute",
    top: "13px",
    right: "-10px",
    fontSize: "25px",
  },
  logoImg: {
    width: "75px",
    margin: " 14px 15px 11px 0px",
    objectFit: "contain",
    "@media (max-width: 500px)": {
      margin: " 11px 1px 3px 0px",
      width: "52px",
    },
  },

  containerHeight: {
    height: "100%",
  },
  mainHeader: {
    justifyContent: "space-between",
    padding: "0px",
  },

  wallet: {
    marginLeft: "10px",
    width: "140px",
    padding: "9px 25px",
    marginTop: "12px",
    "&:hover": {
      background: "#fff",
      color: "#000",
    },
    "@media (max-width: 900px)": {
      marginLeft: "12px",
      marginTop: "12px",
    },
  },
  wallet1: {
    marginLeft: "10px",
    marginTop: "20px",
    padding: "9px 40px",
    "&:hover": {
      background: "#fff",
      color: "#000",
    },
    "@media (max-width: 900px)": {
      marginLeft: "12px",
      marginTop: "12px",
    },
  },

  submenu: {
    borderTop: "3px solid #300760",
    top: "25px !important",
  },
  btn2: {
    marginLeft: "20px",
    padding: " 9px 33px",
  },
  btn1: {
    padding: " 9px 35px",
  },
}));

export default function Header() {
  const {
    toolbar,
    drawerContainer,
    drawericon,
    logoDrawer,
    containerHeight,
    mainHeader,
    wallet,
    wallet1,
    submenu,
    btn2,
    btn1,
  } = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [_active, setActive] = useState("LOGIN");
  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const { mobileView, drawerOpen } = state;
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 1220
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());
  }, []);

  const [open1, setOpen1] = useState({ community: false, user: false });
  const anchorRef = { community: useRef(null), user: useRef(null) };

  const handleClose2 = (event, name) => {
    if (
      anchorRef[name].current &&
      anchorRef[name].current.contains(event.target)
    ) {
      return;
    }

    setOpen1({ ...open1, [name]: false });
  };

  function handleListKeyDown(event, name) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen1({ ...open1, [name]: false });
    }
  }
  const displayDesktop = () => {
    return (
      <Container maxWidth="lg" className="p-0">
        <Toolbar className={toolbar}>
          {femmecubatorLogo}
          <Grid
            container
            item
            direction="row"
            justify="flex-end"
            alignItems="center"
            style={{ paddingLeft: "0px" }}
          >
            <Popper
              open={open1.community}
              anchorEl={anchorRef.community.current}
              role={undefined}
              transition
              disablePortal
              className={submenu}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener
                      onClickAway={(e) => handleClose2(e, "community")}
                    >
                      <MenuList
                        autoFocusItem={open1}
                        id="menu-list-grow"
                        onKeyDown={(e) => handleListKeyDown(e, "community")}
                      >
                        <MenuItem component={Link} to="/fungy-token">
                          Fungy Token
                        </MenuItem>
                        <MenuItem component={Link} to="/faq">
                          Discussion
                        </MenuItem>
                        <MenuItem>Voting</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            <Button
              color="secondary"
              onClick={() => {
                history.push("/");
                window.localStorage.setItem("active", "LOGIN");
              }}
              className={btn1}
              style={
                window.localStorage.getItem("active") === "LOGIN"
                  ? { background: "#6FCFB9", color: "#fff" }
                  : { border: "1px solid #6fcfb9" }
              }
            >
              {localeFunction("landing_button_text_3")}
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button
              color="secondary"
              onClick={() => {
                history.push("/signup");
                window.localStorage.setItem("active", "SINGUP");
              }}
              className={btn1}
              style={
                window.localStorage.getItem("active") === "SINGUP"
                  ? { background: "#6FCFB9", color: "#fff" }
                  : { border: "1px solid #6fcfb9" }
              }
            >
              {localeFunction("landing_button_text_4")}
            </Button>
          </Grid>
        </Toolbar>
      </Container>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));

    return (
      <Toolbar className={mainHeader}>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <div className={drawerContainer}>
            <img className={logoDrawer} src="images/logo.png" alt="" />
            <Button
              variant="contained"
              color="secondary"
              className={wallet}
              aria-controls="simple-menu"
              aria-haspopup="true"
              to="/"
              component={Link}
            >
              {localeFunction("landing_button_text_3")}
            </Button>
            <Button
              variant="contained"
              color="secondary"
              className={wallet}
              aria-controls="simple-menu"
              aria-haspopup="true"
              to="/signUp"
              component={Link}
            >
              {localeFunction("landing_button_text_4")}
            </Button>
          </div>
        </Drawer>

        <div>{femmecubatorLogo}</div>
        <Grid container>
          <Grid item xs={9}></Grid>
          <Grid item xs={3}>
            <IconButton
              className={drawericon}
              {...{
                edge: "start",
                color: "inherit",
                "aria-label": "menu",
                "aria-haspopup": "true",
                onClick: handleDrawerOpen,
              }}
            >
              <MenuIcon
                width="60px"
                height="60px"
                style={{ color: "#6FCFB9", fontSize: "30px" }}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Toolbar>
    );
  };

  const femmecubatorLogo = (
    <Box>
      <Link to="/">
        <Logo className="logoImg" />
      </Link>
    </Box>
  );

  return (
    <>
      <AppBar
        position={history.location.pathname !== "/" ? "relative" : "absolute"}
        elevation={0}
        style={{
          backgroundColor: "#ccc0",
          border: "none",
          background: "#FFFFFF",
          position: "relative",
          boxShadow: "0px 4px 4px rgb(0 0 0 / 10%)",
        }}
      >
        <Container
          maxWidth={history.location.pathname !== "/" ? "lg" : "lg"}
          className={containerHeight}
        >
          {mobileView ? displayMobile() : displayDesktop()}
        </Container>
      </AppBar>
    </>
  );
}
